import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  static values = {
    default: { type: String, default: "" }
  }

  connect() {
    // Set initial tab if specified
    if (this.defaultValue) {
      this.showTab(this.defaultValue)
    }
  }

  select(event) {
    const tabId = event.currentTarget.dataset.tabId
    this.showTab(tabId)
  }

  showTab(tabId) {
    // Update tab styles
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabId === tabId
      tab.classList.toggle("border-indigo-500", isActive)
      tab.classList.toggle("text-indigo-600", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
    })

    // Show/hide panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tabId === tabId
      panel.classList.toggle("hidden", !isActive)
    })
  }
}
